import React, { useState, useEffect, useMemo, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Cookies from 'js-cookie';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import Skeleton from '@material-ui/lab/Skeleton';
import IconButton from '@material-ui/core/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SettingsIcon from '@mui/icons-material/Settings';
import { Drawer, List, ListItem, ListItemText, ListItemIcon } from '@mui/material';
import { Paper } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { MenuItem, Select, TextField, FormControl, InputLabel, createTheme, ThemeProvider, CssBaseline, Checkbox, OutlinedInput, Collapse } from "@mui/material";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Backdrop, CircularProgress } from "@mui/material";

import SecurityIcon from '@mui/icons-material/Security';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import AssessmentIcon from '@mui/icons-material/Assessment';
import BusinessIcon from '@mui/icons-material/Business';
import SNARonda from './snaRonda.js';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PostAddIcon from '@mui/icons-material/PostAdd';
import HomeIcon from '@mui/icons-material/Home';
import BuildIcon from '@mui/icons-material/Build';
import GroupIcon from '@mui/icons-material/Group';
import ContactMailIcon from '@mui/icons-material/ContactMail';

import {
    Box,
    Tooltip
} from '@mui/material';
import { Card, CardContent } from '@mui/material';
import { Email, EmailOutlined, Visibility, VisibilityOff, Message, MessageOutlined } from '@mui/icons-material';
import { ArrowUpward, ArrowDownward } from '@mui/icons-material';

import api from '../../../../../services/api';
import NavegadorGestao from "../../../../../components/NavBarGestao";

import { Button } from "@material-ui/core";

import ExcelJS from 'exceljs';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import { 
    MaterialReactTable,

} from 'material-react-table';
import { useMaterialReactTable } from 'material-react-table';

import ReactApexChart from "react-apexcharts";

import FlagIcon from '@mui/icons-material/Flag'; // Objetivo
import TrendingUpIcon from '@mui/icons-material/TrendingUp'; // Meta
import BlockIcon from '@mui/icons-material/Block'; // Sem/0
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // Mínimo 1
import LooksTwoIcon from '@mui/icons-material/LooksTwo'; // Mínimo 2
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents'; // Alcance Meta
import LooksOneIcon from '@mui/icons-material/LooksOne'; // Mínimo 2


function novaRondaVirtual() {
    window.location.href = "/gestao/operacional/rondavirtual/cadastrar"

}

export default function RondaVirtual() {

    const [darkMode, setDarkMode] = useState(Cookies.get('darkMode') === 'true');
    const [menuAberto, setMenuAberto] = useState(() => {
        const saved = localStorage.getItem('menuLateralRondaAberto');
        return saved !== null ? saved === 'true' : true;
    });

    const handleToggleMenu = () => {
        setMenuAberto(prev => {
            const next = !prev;
            localStorage.setItem('menuLateralRondaAberto', String(next));
            return next;
        });
    };

    const drawerWidth = menuAberto ? 220 : 68;

    useEffect(() => {
        const handleDarkModeChange = () => {
            setDarkMode(Cookies.get('darkMode') === 'true');
        };

        window.addEventListener('darkModeChanged', handleDarkModeChange);

        return () => {
            window.removeEventListener('darkModeChanged', handleDarkModeChange);
        };
    }, []);

    const tableTheme = createTheme({
        palette: {
            mode: darkMode ? 'dark' : 'light',
            ...(darkMode && {
                background: {
                    default: '#121212',
                    paper: '#1e1e1e',
                },
            }),
        },
        components: {
            MuiTablePagination: {
                styleOverrides: {
                    root: {
                        color: darkMode ? '#fff' : '#000',
                    },
                    selectLabel: {
                        color: darkMode ? '#fff' : '#000',
                    },
                    displayedRows: {
                        color: darkMode ? '#fff' : '#000',
                    },
                },
            },
            MuiSelect: {
                styleOverrides: {
                    icon: {
                        color: darkMode ? '#fff' : '#000',
                    },
                    select: {
                        color: darkMode ? '#fff' : '#000',
                    },
                },
            },
        },
    });

    const [openSnaRondaVirtual, setOpenSnaRondaVirtual] = useState(false);
    const [rondaVirtualSna, setRondaVirtualSna] = useState(null);

    const [tipoGrupo, setTipoGrupo] = useState(0);
    const [tipoGrupoTexto, setTipoGrupoTexto] = useState("Grupo de Cliente");

    const handleGrupo = (tipo) => {


        setTreeGrupos([]);
        if (parseInt(tipo, 10) === 0) {
            setTipoGrupo(0);
            setTipoGrupoTexto("Grupo de Cliente");
            setGruposControlesSelecionados([]);
            listarGruposCliente();
        }
        else if (parseInt(tipo, 10) === 1) {
            setTipoGrupo(1);
            setTipoGrupoTexto("Grupo de Controle");
            setGruposClienteSelecionados([]);
            listarGruposControle();
        }
    };

    const [month, setMonth] = useState(
        String(new Date().getMonth() + 1).padStart(2, '0')
    );
    const [year, setYear] = useState(new Date().getFullYear());

    const [inGeracao, setInGeracao] = useState(false);

    const months = [
        { value: 1, label: "Janeiro" },
        { value: 2, label: "Fevereiro" },
        { value: 3, label: "Março" },
        { value: 4, label: "Abril" },
        { value: 5, label: "Maio" },
        { value: 6, label: "Junho" },
        { value: 7, label: "Julho" },
        { value: 8, label: "Agosto" },
        { value: 9, label: "Setembro" },
        { value: 10, label: "Outubro" },
        { value: 11, label: "Novembro" },
        { value: 12, label: "Dezembro" },
    ];

    const handleYearChange = (event) => {
        const value = event.target.value.replace(/\D/g, ""); // Remove caracteres não numéricos
        if (value.length <= 4) {
            setYear(value);
        }
    };


    const handleCloseSnaRondaVirtual = () => {
        setRondaVirtualSna(null);
        setOpenSnaRondaVirtual(false);
    };




    async function handleOpenSnaRondaVirtual(ronda) {
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            await api.get("/v1/protected/rondavirtual/listarporid/" + ronda.id_ronda_virtual, {
                headers: headers
            }).then(function (response) {
                setRondaVirtualSna(response.data);
                setOpenSnaRondaVirtual(true);

            });
        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar informações: " + _err)

        }

    }

    const [openHistorico, setOpenHistorico] = useState(false);
    const [historicoRankingMensal, setHistoricoRankingMensal] = useState([]);


    const [rankingDoGrafico, setRankingDoGrafico] = useState(null);


    const historicoRef = useRef([]);

    useEffect(() => {
        if (historicoRankingMensal?.length) {
            historicoRef.current = historicoRankingMensal;
        }
    }, [historicoRankingMensal]);


    const [mesObservado, setMesObservado] = useState("");

    const [dadosHistorico, setDadosHistorico] = useState({
        series: [{ name: 'Rondas', data: [] }],
        options: {
            chart: { height: '100%', type: 'line', width: '100%' },
            colors: ['#0288d1'],
            dataLabels: { enabled: false },
            stroke: {
                show: true,
                width: 4,
                curve: 'smooth',
                colors: ['#0288d1'],
            },
            responsive: [{
                breakpoint: 768,
                options: {
                    chart: { width: '100%' },
                    legend: { position: 'bottom' },
                },
            }],
            xaxis: {
                categories: [],
                title: { text: 'Mês/Ano' },
            },
            yaxis: {
                title: { text: 'Rondas Mensais' },
            },
            markers: {
                size: 5,
                colors: ['#0288d1'],
                strokeColors: '#fff',
                strokeWidth: 2,
            },
            tooltip: {
                enabled: true,
                shared: false,
                intersect: true,

            },
            fill: { opacity: 1 },
        },
    });


    const handleCloseHistorico = () => {
        setOpenHistorico(false);
        setRankingDoGrafico(null);
        setMesObservado("");
    };



    useEffect(() => {
        if (!dadosHistorico.options.xaxis.categories.length) return;

        const categoria = dadosHistorico.options.xaxis.categories[0];
        setMesObservado(categoria);
        const [mesStr, anoStr] = categoria.split('/');
        const mesSelecionado = parseInt(mesStr, 10);
        const anoSelecionado = parseInt(anoStr, 10);

        const encontrado = historicoRankingMensal.find(
            (item) => item.mes === mesSelecionado && item.ano === anoSelecionado
        );

        if (encontrado) {
            const usuariosOrdenados = [...encontrado.usuarios].sort((a, b) => b.totalRondas - a.totalRondas);
            setRankingDoGrafico(usuariosOrdenados);

        }
    }, [dadosHistorico, historicoRankingMensal]);

    async function listarHistorico() {
        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token,
            };

            const response = await api.get("/v1/protected/rondavirtual/historico", { headers });

            const data = response.data;

            const categorias = [];
            const valores = [];

            data.forEach((item) => {
                const mes = item.mes.toString().padStart(2, '0');
                const label = `${mes}/${item.ano}`;
                categorias.push(label);

                // `usuarios` já é um array, não precisa de JSON.parse
                const usuarios = item.usuarios;
                const totalDoMes = usuarios.reduce(
                    (soma, usuario) => soma + usuario.totalRondas,
                    0
                );
                valores.push(totalDoMes);
            });

            setDadosHistorico((prevState) => ({
                ...prevState,
                series: [{ name: 'Rondas', data: valores }],
                options: {
                    ...prevState.options,
                    xaxis: {
                        ...prevState.options.xaxis,
                        categories: categorias,
                        title: { text: 'Mês/Ano' },
                    },
                },
            }));

            setOpenHistorico(true); // Mostra o gráfico
            setHistoricoRankingMensal(data);

        } catch (err) {
            console.error("Erro ao listar informações: ", err);
        }
    }


    function handleClickNoPonto(label) {
        const [mesStr, anoStr] = label.split('/');
        const mesSelecionado = parseInt(mesStr, 10);
        const anoSelecionado = parseInt(anoStr, 10);

        const encontrado = historicoRef.current.find(
            (item) => item.mes === mesSelecionado && item.ano === anoSelecionado
        );

        if (!encontrado) {
            alert(`Não encontrado: ${label}`);
            return;
        }

        const usuariosOrdenados = [...encontrado.usuarios].sort(
            (a, b) => b.totalRondas - a.totalRondas
        );

        // Evita erro de getBoundingClientRect
        requestAnimationFrame(() => {
            setRankingDoGrafico(usuariosOrdenados);
            setMesObservado(label);
        });
    }

    const [grupoControleSelecionado, setGrupoControleSelecionado] = useState(null);
    const [grupoClienteSelecionado, setGrupoClienteSelecionado] = useState(null);
    const [gruposControlesSelecionados, setGruposControlesSelecionados] = useState([]);
    const [gruposClienteSelecionados, setGruposClienteSelecionados] = useState([]);

    const [selectedMonths, setSelectedMonths] = useState([moment().month() + 1]);
    const [treeGrupos, setTreeGrupos] = useState([]);
    const [loadingTree, setLoadingTree] = useState(false);
    const [treeOpen, setTreeOpen] = useState(true);

    const [loadingRelatoria, setLoadingRelatoria] = useState(true);
    const [gruposControle, setGruposControle] = useState([]);
    const [gruposCliente, setGruposCliente] = useState([]);

    const [loading, setLoading] = useState(true);
    const [rondasVirtuais, setRondasVirtuais] = useState([]);
    const [value, setValue] = useState(0);

    const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
    const [rowCount, setRowCount] = useState(0);
    const [globalFilter, setGlobalFilter] = useState('');
    const [columnFilters, setColumnFilters] = useState([]);
    const [isRefetching, setIsRefetching] = useState(false);
    const [exporting, setExporting] = useState(false);

    const [loadingDashboard, setLoadingDashboard] = useState(true);

    const regras = Cookies.get("regra");

    const [dadosGrafico, setDadosGrafico] = useState({
        series: [
            { name: 'Rondas', data: [] },
        ],
        options: {
            chart: {
                height: '100%',
                type: 'line',
                width: '100%',
            },
            colors: ['#0288d1'], // Cor principal da linha
            dataLabels: {
                enabled: false,
            },
            stroke: {
                show: true,
                width: 4, // Define a espessura da linha
                curve: 'smooth', // Faz a linha suave (opcional)
                colors: ['#0288d1'], // Cor da linha
            },
            responsive: [
                {
                    breakpoint: 768, // Para telas menores que 768px
                    options: {
                        chart: {
                            width: '100%',
                        },
                        legend: {
                            position: 'bottom',
                        },
                    },
                },
            ],
            xaxis: {
                categories: [], // As categorias (dias do mês)
                title: {
                    text: 'Dias do Mês', // Opcional: título do eixo X
                },
            },
            yaxis: {
                title: {
                    text: 'Rondas Mensais',
                },
            },
            markers: {
                size: 5, // Tamanho dos pontos
                colors: ['#0288d1'], // Cor dos pontos
                strokeColors: '#fff', // Cor da borda do ponto
                strokeWidth: 2, // Espessura da borda dos pontos
            },
            fill: {
                opacity: 1,
            },
        },
    });


    async function listarObjetos(opts = {}) {
        const pag = opts.pagination || pagination;
        const gFilter = opts.globalFilter !== undefined ? opts.globalFilter : globalFilter;
        const cFilters = opts.columnFilters !== undefined ? opts.columnFilters : columnFilters;

        if (rondasVirtuais.length === 0) {
            setLoading(true);
        } else {
            setIsRefetching(true);
        }

        try {
            const token = Cookies.get('token');
            const headers = {
                'Authorization': 'Bearer ' + token
            };

            const executorFilter = cFilters.find(f => f.id === 'nome_amigavel')?.value || '';
            const dataHoraFilter = cFilters.find(f => f.id === 'data_hora_conclusao_formatada')?.value || '';
            const statusFilter = cFilters.find(f => f.id === 'status')?.value || '';
            const contaFilter = cFilters.find(f => f.id === 'conta_instalacao')?.value || '';
            const idFilter = cFilters.find(f => f.id === 'id_ronda_virtual')?.value || '';

            const response = await api.get("v1/protected/rondavirtual/listartodospaginado", {
                headers: headers,
                params: {
                    busca: gFilter || '',
                    executor: executorFilter,
                    dataHora: dataHoraFilter,
                    status: statusFilter,
                    conta: contaFilter,
                    id: idFilter,
                    page: pag.pageIndex,
                    size: pag.pageSize,
                }
            });

            const dados = response.data?.dados || [];
            const total = response.data?.total || 0;

            const updatedData = dados.map(item => {
                item.conta_instalacao = `${item.identificador_integrador || ''} - `;
                item.conta_instalacao +=
                    item.tipo_instalacao === 0
                        ? `${item.nome || ''} ${item.sobrenome || ''}`.trim()
                        : (item.nome_empresarial && item.nome_empresarial.trim() !== ""
                            ? item.nome_empresarial
                            : (item.nome_fantasia || ''));

                item.status =
                    item.status_ronda_virtual === 0 && item.data_hora_designacao !== null
                        ? "EM EXECUÇÃO"
                        : item.status_ronda_virtual === 1 && item.data_hora_designacao !== null
                            ? "ENCERRADO" :
                            item.status_ronda_virtual === 0 && item.data_hora_designacao === null
                                ? "DISPONÍVEL"
                                : "INDEFINIDO";

                item.data_hora_conclusao_formatada = item.data_hora_finalizacao
                    ? moment(item.data_hora_finalizacao, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')
                    : '-';

                item.executor_display = item.nome_amigavel ? item.nome_amigavel : 'Não Atribuído';

                return item;
            });

            setRondasVirtuais(updatedData);
            setRowCount(total);
            setFilteredData(updatedData);
            setLoading(false);
            setIsRefetching(false);
        } catch (_err) {
            console.log("Erro ao listar Rondas Virtuais: " + _err);
            setLoading(false);
            setIsRefetching(false);
        }
    }

    useEffect(() => {
        if (value === 1) {
            const timer = setTimeout(() => {
                listarObjetos({ pagination, globalFilter, columnFilters });
            }, 300);
            return () => clearTimeout(timer);
        }
    }, [pagination, globalFilter, columnFilters, value]);



    const [infoDashboard, setInfoDashboard] = useState(null);

    async function listarInfoDashboard() {


        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            await api.get("v1/protected/rondavirtual/listarinfodashboard", {
                headers: headers
            }).then(function (response) {

                setInfoDashboard(response.data);


                // Formatando os dados para o gráfico
                const categorias = response.data.rondasMensaisParaGrafico.map(item => {
                    const date = new Date(item.data); // Converte a string de data para um objeto Date
                    const day = date.getDate(); // Obtém o dia
                    const month = date.toLocaleString('default', { month: 'short' }); // Obtém o mês abreviado (Ex: Jan, Feb, Mar)
                    return `${day} ${month}`; // Combina dia e mês abreviado
                });
                const valores = response.data.rondasMensaisParaGrafico.map(item => item.rondas);


                setDadosGrafico(prevState => ({
                    ...prevState,
                    series: [
                        { name: 'Rondas', data: valores },
                    ],
                    options: {
                        ...prevState.options,
                        xaxis: {
                            categories: categorias, // Passa apenas os dias como categorias
                            title: {
                                text: 'Dias do Mês', // Opcional: Título do eixo X
                            },
                        },
                        dataLabels: {
                            enabled: true, // Ativa os rótulos com os valores


                        },
                        tooltip: {
                            enabled: true, // Desativa o tooltip (opcional, para não interferir com os valores fixos)
                        },
                    }
                }));

                setLoadingDashboard(false);

            });


        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar Rondas Virtuais: " + _err)

        }

    }



    async function listarGruposCliente() {


        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            await api.get("v1/protected/grupocliente/listartodos", {
                headers: headers
            }).then(function (response) {

                setGruposCliente(response.data);
                setLoadingRelatoria(false);

            });


        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar Rondas Virtuais: " + _err)

        }

    }


    async function listarGruposControle() {


        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            await api.get("v1/protected/grupocontrole/listartodos", {
                headers: headers
            }).then(function (response) {

                setGruposControle(response.data);
                setLoadingRelatoria(false);

            });


        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar Rondas Virtuais: " + _err)

        }

    }

    useEffect(() => {

        listarInfoDashboard();


    }, []);

    useEffect(() => {
        async function carregarInstalacoesTree() {
            if (parseInt(tipoGrupo, 10) === 0 && gruposClienteSelecionados && gruposClienteSelecionados.length > 0) {
                setLoadingTree(true);
                try {
                    const token = Cookies.get('token');
                    const resultados = await Promise.all(
                        gruposClienteSelecionados.map(async (g) => {
                            try {
                                const res = await api.get(`v1/protected/grupocliente/listarinstalacoes/${g.id_grupo_cliente}`, {
                                    headers: { 'Authorization': 'Bearer ' + token }
                                });
                                return {
                                    grupoNome: g.nome,
                                    idGrupo: g.id_grupo_cliente,
                                    instalacoes: res.data || []
                                };
                            } catch (e) {
                                return { grupoNome: g.nome, idGrupo: g.id_grupo_cliente, instalacoes: [] };
                            }
                        })
                    );
                    setTreeGrupos(resultados);
                } catch (err) {
                    console.log("Erro ao carregar instalações dos Grupos Cliente:", err);
                    setTreeGrupos([]);
                } finally {
                    setLoadingTree(false);
                }
            } else if (parseInt(tipoGrupo, 10) === 1 && gruposControlesSelecionados && gruposControlesSelecionados.length > 0) {
                const resultados = gruposControlesSelecionados.map((g) => ({
                    grupoNome: g.nome,
                    idGrupo: g.id_grupo_controle,
                    instalacoes: Array.from(g.instalacoes || [])
                }));
                setTreeGrupos(resultados);
            } else {
                setTreeGrupos([]);
            }
        }
        carregarInstalacoesTree();
    }, [tipoGrupo, gruposClienteSelecionados, gruposControlesSelecionados]);


    function returnDescricaoGrupoControle(grupo) {
        var texto = grupo.id_grupo_controle + "-" + grupo.nome;
        return texto;
    }


    function returnDescricaoGrupoCliente(grupo) {
        var texto = grupo.id_grupo_cliente + "-" + grupo.nome;
        return texto;
    }



    async function visualizar(caminho) {

        try {
            const token = Cookies.get('token');
            const headers = {
                'Authorization': 'Bearer ' + token
            }

            console.log("Caminho: " + caminho);
            const cadastro = {

                dado1: caminho

            };
            const response = await api.post("/v1/protected/notificacoes/baixarPdf", cadastro, {
                headers: headers,
                responseType: 'arraybuffer',  // Indica que a resposta é um array de bytes
            });

            // Cria um blob com os dados recebidos
            const blob = new Blob([response.data], { type: 'application/pdf' });

            // Cria uma URL do blob
            const blobUrl = URL.createObjectURL(blob);

            // Abre uma nova guia com o arquivo PDF
            window.open(blobUrl, '_blank');
        } catch (error) {
            // Trate os erros conforme necessário
            console.log("Erro ao baixar o arquivo: " + error);
        }
    }



    async function gerarRelatorioRondaVirtual() {
        setInGeracao(true);
        let id_grupo = 0;

        const idsCliente = (gruposClienteSelecionados || []).map((g) => g.id_grupo_cliente);
        const idsControle = (gruposControlesSelecionados || []).map((g) => g.id_grupo_controle);

        if (parseInt(tipoGrupo, 10) === 0 && idsCliente.length === 0) {
            setInGeracao(false);
            alert("Selecione pelo menos 1 Grupo de Cliente");
            return;
        }

        if (parseInt(tipoGrupo, 10) === 1 && idsControle.length === 0) {
            setInGeracao(false);
            alert("Selecione pelo menos 1 Grupo de Controle");
            return;
        }

        if (!selectedMonths || selectedMonths.length === 0) {
            setInGeracao(false);
            alert("Selecione pelo menos 1 mês");
            return;
        }

        try {

            const dados = {
                tipo_grupo: tipoGrupo,
                id_usuario: Cookies.get("id_usuario"),
                id_grupo: idsCliente[0] || idsControle[0] || 0,
                ids_grupos_cliente: idsCliente,
                ids_grupos_controle: idsControle,
                mes: selectedMonths[0],
                meses: selectedMonths,
                ano: year,
            };

            console.log("[RONDA_FRONT_DEBUG] Enviando dados para gerar relatório:", dados);

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            };
            const response = await api.put('/v1/protected/rondavirtual/gerarrelatorio', dados, { headers: headers });

            console.log("[RONDA_FRONT_DEBUG] Resposta da API recebida:", response.data);

            const relatorio = response.data;
            if (relatorio && relatorio.caminho_arquivo) {
                var caminho_temp = relatorio.caminho_arquivo.replace(
                    "/home/wwgrup/rondavirtual/",
                    "https://gruporosinetos.com/rvmidias/"
                );

                console.log("[RONDA_FRONT_DEBUG] URL pública do relatório PDF:", caminho_temp);

                const win = window.open(caminho_temp, "_blank");
                if (!win || win.closed || typeof win.closed === 'undefined') {
                    console.warn("[RONDA_FRONT_WARN] Abertura de nova guia foi bloqueada pelo navegador.");
                    alert("Relatório PDF gerado com sucesso! Se a nova guia não abriu automaticamente, acesse o link:\n\n" + caminho_temp);
                } else {
                    console.log("[RONDA_FRONT_DEBUG] Nova guia com PDF aberta com sucesso!");
                }
            } else {
                console.error("[RONDA_FRONT_ERROR] O servidor retornou a resposta, mas o campo 'caminho_arquivo' está ausente ou nulo.");
                alert("O servidor processou o relatório, mas não retornou o arquivo PDF gerado.");
            }

        } catch (_err) {
            console.error("[RONDA_FRONT_ERROR] Erro ao gerar relatório de Rondas Virtuais:", _err);
            const msg = _err.response?.data?.message || _err.response?.data || _err.message || "Erro de Conexão";
            alert("Falha ao gerar relatório de Rondas Virtuais: " + msg);
        } finally {
            setInGeracao(false);
        }


    }




    const handleExportExcel = async () => {
        setExporting(true);
        try {
            const token = Cookies.get('token');
            const headers = { 'Authorization': 'Bearer ' + token };

            const executorFilter = columnFilters.find(f => f.id === 'nome_amigavel')?.value || '';
            const dataHoraFilter = columnFilters.find(f => f.id === 'data_hora_conclusao_formatada')?.value || '';
            const statusFilter = columnFilters.find(f => f.id === 'status')?.value || '';
            const contaFilter = columnFilters.find(f => f.id === 'conta_instalacao')?.value || '';
            const idFilter = columnFilters.find(f => f.id === 'id_ronda_virtual')?.value || '';

            const response = await api.get("v1/protected/rondavirtual/listartodospaginado", {
                headers,
                params: {
                    busca: globalFilter || '',
                    executor: executorFilter,
                    dataHora: dataHoraFilter,
                    status: statusFilter,
                    conta: contaFilter,
                    id: idFilter,
                    page: 0,
                    size: 10000,
                }
            });

            const exportData = (response.data?.dados || []).map(item => {
                const conta = `${item.identificador_integrador || ''} - ${
                    item.tipo_instalacao === 0
                        ? `${item.nome || ''} ${item.sobrenome || ''}`.trim()
                        : (item.nome_empresarial && item.nome_empresarial.trim() !== ""
                            ? item.nome_empresarial
                            : (item.nome_fantasia || ''))
                }`;
                const status =
                    item.status_ronda_virtual === 0 && item.data_hora_designacao !== null
                        ? "EM EXECUÇÃO"
                        : item.status_ronda_virtual === 1 && item.data_hora_designacao !== null
                            ? "ENCERRADO" :
                            item.status_ronda_virtual === 0 && item.data_hora_designacao === null
                                ? "DISPONÍVEL"
                                : "INDEFINIDO";
                const conclusao = item.data_hora_finalizacao
                    ? moment(item.data_hora_finalizacao, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')
                    : '-';

                return [
                    item.id_ronda_virtual,
                    status,
                    conclusao,
                    item.nome_grupo || '-',
                    conta,
                    item.nome_amigavel || 'Não Atribuído',
                    item.duracao != null ? item.duracao : '-'
                ];
            });

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Rondas Virtuais');

            const headersList = ['ID', 'STATUS', 'Data e Hora Conclusão', 'Grupo Cliente', 'Conta/Instalação', 'Executor', 'Duração (min)'];

            worksheet.addTable({
                name: 'RondasVirtuais',
                ref: 'A1',
                headerRow: true,
                totalsRow: false,
                style: { showRowStripes: true },
                columns: headersList.map(h => ({ name: h, filterButton: true })),
                rows: exportData,
            });

            const headerRow = worksheet.getRow(1);
            headerRow.eachCell((cell) => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FF1E1E1E' }
                };
                cell.font = { color: { argb: 'FFFFFFFF' }, bold: true };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });

            worksheet.columns.forEach((column, i) => {
                let maxLen = headersList[i].length;
                exportData.forEach(row => {
                    const val = row[i] ? String(row[i]) : '';
                    if (val.length > maxLen) maxLen = val.length;
                });
                column.width = Math.min(Math.max(maxLen + 4, 12), 40);
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `rondas_virtuais_${moment().format('YYYYMMDD_HHmmss')}.xlsx`;
            link.click();
        } catch (err) {
            console.error("Erro ao exportar Excel:", err);
            alert("Erro ao exportar tabela em Excel!");
        } finally {
            setExporting(false);
        }
    };

    const handleExportPDF = async () => {
        setExporting(true);
        try {
            const token = Cookies.get('token');
            const headers = { 'Authorization': 'Bearer ' + token };

            const executorFilter = columnFilters.find(f => f.id === 'nome_amigavel')?.value || '';
            const dataHoraFilter = columnFilters.find(f => f.id === 'data_hora_conclusao_formatada')?.value || '';
            const statusFilter = columnFilters.find(f => f.id === 'status')?.value || '';
            const contaFilter = columnFilters.find(f => f.id === 'conta_instalacao')?.value || '';
            const idFilter = columnFilters.find(f => f.id === 'id_ronda_virtual')?.value || '';

            const response = await api.get("v1/protected/rondavirtual/listartodospaginado", {
                headers,
                params: {
                    busca: globalFilter || '',
                    executor: executorFilter,
                    dataHora: dataHoraFilter,
                    status: statusFilter,
                    conta: contaFilter,
                    id: idFilter,
                    page: 0,
                    size: 10000,
                }
            });

            const exportData = (response.data?.dados || []).map(item => {
                const conta = `${item.identificador_integrador || ''} - ${
                    item.tipo_instalacao === 0
                        ? `${item.nome || ''} ${item.sobrenome || ''}`.trim()
                        : (item.nome_empresarial && item.nome_empresarial.trim() !== ""
                            ? item.nome_empresarial
                            : (item.nome_fantasia || ''))
                }`;
                const status =
                    item.status_ronda_virtual === 0 && item.data_hora_designacao !== null
                        ? "EM EXECUÇÃO"
                        : item.status_ronda_virtual === 1 && item.data_hora_designacao !== null
                            ? "ENCERRADO" :
                            item.status_ronda_virtual === 0 && item.data_hora_designacao === null
                                ? "DISPONÍVEL"
                                : "INDEFINIDO";
                const conclusao = item.data_hora_finalizacao
                    ? moment(item.data_hora_finalizacao, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')
                    : '-';

                return [
                    item.id_ronda_virtual,
                    status,
                    conclusao,
                    item.nome_grupo || '-',
                    conta,
                    item.nome_amigavel || 'Não Atribuído',
                    item.duracao != null ? item.duracao : '-'
                ];
            });

            const doc = new jsPDF('landscape');
            doc.setFontSize(14);
            doc.text('Relatório de Rondas Virtuais', 14, 15);
            doc.setFontSize(10);
            doc.text(`Gerado em: ${moment().format('DD/MM/YYYY HH:mm:ss')} - Total de registros: ${exportData.length}`, 14, 22);

            const tableHeaders = ['ID', 'STATUS', 'Data e Hora Conclusão', 'Grupo Cliente', 'Conta/Instalação', 'Executor', 'Duração (min)'];

            autoTable(doc, {
                head: [tableHeaders],
                body: exportData,
                startY: 26,
                styles: { fontSize: 8 },
                headStyles: { fillColor: [0, 0, 139] },
            });

            doc.save(`rondas_virtuais_${moment().format('YYYYMMDD_HHmmss')}.pdf`);
        } catch (err) {
            console.error("Erro ao exportar PDF:", err);
            alert("Erro ao exportar tabela em PDF!");
        } finally {
            setExporting(false);
        }
    };

    const columns = useMemo(
        () => [

            {
                accessorKey: 'id_ronda_virtual', //normal accessorKey
                header: 'ID',
                size: 70,
                filterFn: 'includesString',
            },

            {
                accessorKey: 'status', // normal accessorKey
                header: 'STATUS',
                size: 180,
                filterFn: 'includesString',
                Cell: ({ renderedCellValue, row }) => {
                    return (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span
                                style={{
                                    padding: "5px 10px",
                                    border: "1px solid #ccc",
                                    borderRadius: "5px",
                                    boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                    backgroundColor: renderedCellValue === "ENCERRADO" ? "#b2fab4" : "#fbb4b4", // Verde médio ou vermelho médio
                                    color: renderedCellValue === "ENCERRADO" ? "#2e7d32" : "#c62828", // Verde escuro ou vermelho escuro
                                    fontWeight: "bold",
                                    fontSize: 12,
                                }}
                            >
                                {renderedCellValue}
                            </span>
                            {renderedCellValue === "ENCERRADO" && (
                                <button
                                    onClick={() => handleOpenSnaRondaVirtual(row.original)} // Passando o objeto da linha
                                    style={{
                                        marginLeft: '1px',
                                        padding: '1px 1px',
                                        backgroundColor: darkMode ? '#2d2d2d' : '#ffffff',
                                        color: 'green',
                                        border: 'none',
                                        borderRadius: '1px',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                >
                                    <VisibilityIcon style={{ marginRight: '5px' }} />
                                </button>
                            )}

                        </div>
                    );
                },
            },

            {
                accessorKey: 'data_hora_conclusao_formatada',
                header: 'Data e Hora Conclusão',
                size: 180,
                Cell: ({ cell }) => {
                    return (
                        <span style={{ fontSize: 13, color: darkMode ? '#fff' : 'black', fontWeight: 'bold' }}>
                            {cell.getValue() || '-'}
                        </span>
                    );
                },
                filterFn: 'includesString',
                enableSorting: true,
                enableColumnFilter: true,
            },

            {
                accessorKey: 'nome_grupo', //normal accessorKey
                header: 'Grupo Cliente',
                size: 100,
                filterFn: 'includesString',
            },

            {
                accessorKey: 'conta_instalacao', // normal accessorKey
                header: 'Conta/Instalação',
                size: 350,
                filterFn: 'includesString',
                Cell: ({ row }) => {
                    const idInstalacao = row.original.id_instalacao; // Obtém o id_instalacao
                    const contaInstalacao = row.original.conta_instalacao; // Obtém o valor de conta_instalacao

                    return (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <a
                                href={`/gestao/administracao/clientes/gerenciarcliente/instalacao/gerenciarinstalacao/${idInstalacao}/0`}
                                style={{ color: 'green', textDecoration: 'none' }} // Remove o sublinhado
                                target="_blank"
                                rel="noreferrer"
                            >
                                <SettingsIcon fontSize="small" /> {/* Ícone de engrenagem */}
                            </a>
                            <span>{contaInstalacao}</span> {/* Exibe o texto da conta */}

                        </div>
                    );
                },
            },
            {
                accessorKey: 'nome_amigavel', //normal accessorKey
                header: 'Executor',
                size: 160,
                filterFn: 'includesString',
                enableColumnFilter: true,
                Cell: ({ row }) => {
                    return (
                        <span
                            style={{
                                fontWeight: "bold",
                            }}
                        >
                            {row.original.executor_display || row.original.nome_amigavel || 'Não Atribuído'}
                        </span>
                    );
                },
            },

            {
                accessorKey: 'duracao', //normal accessorKey
                header: 'Duração (minutos)',
                size: 100,
            },

        ],
        [darkMode, regras, columnFilters, globalFilter],
    );


    const handleClickVizualizar = (event, row) => {

        visualizar(row.caminho_arquivo_original);
    };

    const handleMenuClick = (newValue) => {
        if (newValue === 0) {
            listarInfoDashboard();
        } else if (newValue === 1) {
            listarObjetos();
        } else if (newValue === 2) {
            if (parseInt(tipoGrupo, 10) === 0) {
                listarGruposCliente();
            } else if (parseInt(tipoGrupo, 10) === 1) {
                listarGruposControle();
            }
        }
        setValue(newValue);
    };





    async function handleClickDeletarRondaVirtual(id) {

        const confirmacao = window.confirm(`Tem certeza que deseja deletar a Ronda Virtual com ID: ${id}?`);

        if (!confirmacao) {
            // Usuário cancelou a ação
            return;
        }

        try {
            const cadastro = {};
            const headers = { 'Authorization': 'Bearer ' + Cookies.get("token") };


            await api.delete("v1/protected/rondavirtual/deletar/" + id, {
                headers: headers
            }).then(function (response) {

                if (response.data) {
                    alert("Ronda Virtual Removida");
                    listarObjetos();

                } else {
                    alert("Erro ao deletar Ronda Virtual!");
                    return;
                }

            });




        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            alert("Erro ao listar Rondas Virtuais: " + _err)
        }
    }


    const [rankingSelecao, setRankingSelecao] = useState('Hoje');


    const [filteredData, setFilteredData] = useState([]);



    const table = useMaterialReactTable({
        columns: columns,
        data: rondasVirtuais,
        enableGlobalFilterModes: false,
        enablePagination: true,
        manualPagination: true,
        manualFiltering: true,
        rowCount: rowCount,
        onPaginationChange: setPagination,
        onGlobalFilterChange: setGlobalFilter,
        onColumnFiltersChange: setColumnFilters,
        state: {
            pagination,
            globalFilter,
            columnFilters,
            isLoading: loading,
            showProgressBars: isRefetching,
        },
        enableRowActions: true,
        positionActionsColumn: 'first',
        displayColumnDefOptions: {
            'mrt-row-actions': {
                header: 'Ações',
                size: 90,
            },
        },
        paginationDisplayMode: 'pages',
        getRowId: (row) => row.id_ronda_virtual,
        enableTopToolbar: true,
        enableBottomToolbar: true,
        enableColumnFilters: true,
        enableColumnActions: false,
        sortable: false,
        enableSorting: false,
        enableRowSelection: false,
        enableExpanding: false,
        enableColumnPinning: true,
        enableColumnResizing: true,
        enableStickyHeader: true,
        initialState: {
            showGlobalFilter: true,
            density: 'compact',
        },
        muiPaginationProps: {
            rowsPerPageOptions: [10, 25, 50, 100, 250, 500],
            variant: 'outlined',
        },
        muiTablePaperProps: {
            sx: {
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                bgcolor: darkMode ? '#1e1e1e' : '#fff',
                color: darkMode ? '#fff' : 'inherit',
                overflow: 'hidden',
            }
        },
        muiTableContainerProps: {
            sx: {
                flexGrow: 1,
                overflowY: 'auto',
                overflowX: 'auto',
            }
        },
        muiTopToolbarProps: {
            sx: {
                bgcolor: darkMode ? '#121212' : 'background.default',
                '& .MuiIconButton-root': {
                    color: darkMode ? '#fff !important' : 'inherit',
                },
                '& .MuiSvgIcon-root': {
                    color: darkMode ? '#fff !important' : 'inherit',
                },
                '& .MuiInputBase-root': {
                    color: darkMode ? '#fff !important' : 'inherit',
                }
            },
        },
        renderTopToolbarCustomActions: () => (
            <Box sx={{ display: 'flex', gap: '0.75rem', p: '4px', flexWrap: 'wrap', alignItems: 'center' }}>
                <Button
                    color="primary"
                    variant="contained"
                    onClick={novaRondaVirtual}
                    style={{ fontSize: 12, textTransform: 'none', fontWeight: 'bold' }}
                >
                    Nova Ronda Virtual
                </Button>
                <Button
                    color="primary"
                    variant="contained"
                    disabled={exporting}
                    onClick={handleExportExcel}
                    startIcon={<FileDownloadIcon />}
                    style={{ fontSize: 12, textTransform: 'none', fontWeight: 'bold' }}
                >
                    {exporting ? 'Exportando...' : 'Exportar Excel'}
                </Button>
                <Button
                    color="secondary"
                    variant="contained"
                    disabled={exporting}
                    onClick={handleExportPDF}
                    startIcon={<PictureAsPdfIcon />}
                    style={{ fontSize: 12, textTransform: 'none', fontWeight: 'bold' }}
                >
                    {exporting ? 'Exportando...' : 'Exportar PDF'}
                </Button>
                <span
                    style={{
                        fontWeight: 'bold',
                        color: darkMode ? '#fff' : '#333',
                        marginLeft: '10px',
                        fontSize: '13px',
                        display: 'flex',
                        alignItems: 'center'
                    }}
                >
                    Total: {rowCount} registros
                </span>
            </Box>
        ),
        muiBottomToolbarProps: {
            sx: {
                bgcolor: darkMode ? '#121212' : 'background.default',
                '& .MuiIconButton-root': {
                    color: darkMode ? '#fff !important' : 'inherit',
                },
                '& .MuiSvgIcon-root': {
                    color: darkMode ? '#fff !important' : 'inherit',
                },
                '& .MuiTablePagination-root': {
                    color: darkMode ? '#fff !important' : 'inherit',
                }
            },
        },
        muiTableHeadCellProps: {
            sx: {
                backgroundColor: darkMode ? '#000 !important' : '#fff !important',
                color: darkMode ? '#fff !important' : '#000 !important',
                '& .Mui-TableHeadCell-Content-Labels': {
                    color: darkMode ? '#fff !important' : '#000 !important',
                },
                '& .MuiIconButton-root': {
                    color: darkMode ? '#fff !important' : 'inherit',
                },
                '& .MuiInputBase-root': {
                    color: darkMode ? '#fff !important' : 'inherit',
                }
            },
        },
        muiTableBodyCellProps: {
            sx: {
                color: darkMode ? '#fff' : 'inherit',
            },
        },
        muiTableBodyRowProps: ({ row }) => ({
            sx: {
                backgroundColor: row.index % 2 === 0 ? (darkMode ? '#1e1e1e' : '#f9f9f9') : (darkMode ? '#2d2d2d' : '#e0e0e0'),
                transition: 'background-color 0.3s',
                '&:hover': {
                    backgroundColor: darkMode ? '#333' : '#d0f0ff',
                },
            },
        }),
        enableFullScreenToggle: true,
        renderRowActions: ({ row }) => (
            <Box sx={{ display: 'flex', gap: '0.25rem', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                <Tooltip title="Gerenciar">
                    <IconButton
                        color="primary"
                        href={`/gestao/operacional/rondavirtual/gerenciar/${row.original.id_ronda_virtual}`}
                        sx={{ color: darkMode ? '#90caf9' : 'primary.main', p: '4px' }}
                        size="small"
                    >
                        <SettingsIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
                {regras && regras.includes("ROOT_MASTER") && (
                    <Tooltip title="Deletar">
                        <IconButton
                            sx={{ color: '#f44336', p: '4px' }}
                            onClick={() => handleClickDeletarRondaVirtual(row.original.id_ronda_virtual)}
                            size="small"
                        >
                            <DeleteIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                )}
            </Box>
        ),
    });

    const chartOptions = useMemo(() => {
        return {
            ...dadosGrafico.options,
            chart: {
                ...dadosGrafico.options?.chart,
                background: 'transparent',
                foreColor: darkMode ? '#e0e0e0' : '#333333',
                toolbar: {
                    show: true,
                    tools: {
                        download: true,
                        selection: false,
                        zoom: false,
                        zoomin: false,
                        zoomout: false,
                        pan: false,
                        reset: false,
                    }
                }
            },
            theme: {
                mode: darkMode ? 'dark' : 'light',
            },
            colors: ['#0288d1'],
            stroke: {
                show: true,
                width: 3,
                curve: 'smooth',
                colors: ['#0288d1'],
            },
            dataLabels: {
                enabled: true,
                offsetY: -8,
                style: {
                    colors: [darkMode ? '#ffffff' : '#000000'],
                    fontSize: '12px',
                    fontWeight: 'bold',
                },
                background: {
                    enabled: false,
                },
                dropShadow: {
                    enabled: false,
                }
            },
            grid: {
                borderColor: darkMode ? '#333333' : '#e0e0e0',
                strokeDashArray: 3,
            },
            xaxis: {
                ...dadosGrafico.options?.xaxis,
                labels: {
                    style: {
                        colors: darkMode ? '#e0e0e0' : '#333333',
                    },
                },
                title: {
                    ...dadosGrafico.options?.xaxis?.title,
                    style: {
                        color: darkMode ? '#e0e0e0' : '#333333',
                    },
                },
                axisBorder: {
                    color: darkMode ? '#555555' : '#e0e0e0',
                },
                axisTicks: {
                    color: darkMode ? '#555555' : '#e0e0e0',
                },
            },
            yaxis: {
                ...dadosGrafico.options?.yaxis,
                labels: {
                    style: {
                        colors: darkMode ? '#e0e0e0' : '#333333',
                    },
                },
                title: {
                    ...dadosGrafico.options?.yaxis?.title,
                    style: {
                        color: darkMode ? '#e0e0e0' : '#333333',
                    },
                },
            },
            tooltip: {
                theme: darkMode ? 'dark' : 'light',
            },
        };
    }, [dadosGrafico.options, darkMode]);

    const historicoChartOptions = useMemo(() => {
        return {
            ...dadosHistorico.options,
            chart: {
                ...dadosHistorico.options?.chart,
                background: 'transparent',
                foreColor: darkMode ? '#e0e0e0' : '#333333',
                events: {
                    dataPointSelection: function (event, chartContext, opts) {
                        const label = opts.w?.globals?.categoryLabels?.[opts.dataPointIndex];
                        if (label) {
                            handleClickNoPonto(label);
                        }
                    }
                }
            },
            theme: {
                mode: darkMode ? 'dark' : 'light',
            },
            grid: {
                borderColor: darkMode ? '#333333' : '#e0e0e0',
                strokeDashArray: 3,
            },
            xaxis: {
                ...dadosHistorico.options?.xaxis,
                labels: {
                    style: {
                        colors: darkMode ? '#e0e0e0' : '#333333',
                    },
                },
                title: {
                    ...dadosHistorico.options?.xaxis?.title,
                    style: {
                        color: darkMode ? '#e0e0e0' : '#333333',
                    },
                },
                axisBorder: {
                    color: darkMode ? '#555555' : '#e0e0e0',
                },
                axisTicks: {
                    color: darkMode ? '#555555' : '#e0e0e0',
                },
            },
            yaxis: {
                ...dadosHistorico.options?.yaxis,
                labels: {
                    style: {
                        colors: darkMode ? '#e0e0e0' : '#333333',
                    },
                },
                title: {
                    ...dadosHistorico.options?.yaxis?.title,
                    style: {
                        color: darkMode ? '#e0e0e0' : '#333333',
                    },
                },
            },
            tooltip: {
                theme: darkMode ? 'dark' : 'light',
            },
        };
    }, [dadosHistorico.options, darkMode]);

    function handleSetGrupoControle(grupo) {
        setGrupoControleSelecionado(grupo);
    }

    function handleSetGrupoCliente(grupo) {
        setGrupoClienteSelecionado(grupo);
    }

    return (
        <div style={{ backgroundColor: darkMode ? '#121212' : 'transparent', color: darkMode ? '#fff' : 'inherit', minHeight: '100vh' }}>

            <NavegadorGestao
                Operacional={true}
                RondaVirtual={true}
                corFundo={darkMode ? '#1e1e1e' : 'white'} travado={true} corTexto={darkMode ? 'white' : 'black'}
            />

            {value === 0 &&
                <div style={{ paddingTop: 5, paddingLeft: drawerWidth + 12, paddingRight: 15, width: '100%', backgroundColor: darkMode ? '#121212' : '#f0f4f4', transition: 'padding-left 0.3s ease', minHeight: '100vh' }}>
                    {!loadingDashboard &&
                        <Grid item xs={12} container style={{ width: '100%', margin: 1 }} direction={'row'} >

                            {/* Linha 1 */}
                            <Grid item xs={12} container
                                style={{ width: '100%', margin: 1 }}
                                direction={'row'}
                                spacing={1}
                            >
                                <Grid item xs={12} sm={2}
                                    style={{
                                        padding: '10px',
                                        backgroundColor: darkMode ? '#1e293b' : '#00008B',
                                        border: darkMode ? '1px solid rgba(255, 255, 255, 0.1)' : 'none',
                                        color: 'white',
                                        borderRadius: '8px',
                                        textAlign: 'center',
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        margin: '2px',
                                        display: 'flex', // Adiciona flexbox
                                        flexDirection: 'column', // Coloca os itens em coluna
                                        alignItems: 'center', // Centraliza horizontalmente
                                        justifyContent: 'center', // Centraliza verticalmente
                                    }}
                                    alignItems="center"
                                    justifyContent="center"
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between', // Espaçamento entre os itens
                                            paddingTop: '10px',
                                            padding: '1px',
                                            borderRadius: '8px',
                                            color: 'white',
                                        }}
                                    >
                                        <FlagIcon />
                                        <span style={{ fontWeight: 'bold' }}>
                                            Metas
                                        </span>
                                    </div>


                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between', // Espaçamento entre os itens
                                            paddingTop: '10px',
                                            padding: '1px',
                                            borderRadius: '8px',
                                            color: 'white',
                                            margin: 10,
                                        }}
                                    >
                                        <span style={{ display: 'flex', alignItems: 'center', marginRight: '16px' }}>
                                            <HomeIcon style={{ marginRight: '2px', color: '#FFD700' }} />
                                            <Tooltip title="Número de Instalações Ativadas">
                                                <Typography variant="body1">{infoDashboard.dadosMeta.objetivo}</Typography>
                                            </Tooltip>
                                        </span>

                                        <span style={{ display: 'flex', alignItems: 'center', marginRight: '16px' }}>
                                            <SecurityIcon style={{ marginRight: '2px', color: '#FFD700' }} />
                                            <Tooltip title="A meta é 2 rondas mensais em cada Instalação ativa">
                                                <Typography variant="body1">{infoDashboard.dadosMeta.meta}</Typography>
                                            </Tooltip>

                                        </span>
                                    </div>

                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between', // Espaçamento entre os itens
                                            paddingTop: '10px',
                                            padding: '1px',
                                            borderRadius: '8px',
                                            color: 'white',
                                            margin: 10,
                                        }}
                                    >
                                        <span style={{ display: 'flex', alignItems: 'center', marginRight: '16px' }}>
                                            <LooksOneIcon style={{ marginRight: '2px', color: '#FFD700' }} />
                                            <Tooltip title="Porcentagem de Instalações que receberam no minimo uma ronda virtual">
                                                <Typography variant="body1">{parseInt(infoDashboard.dadosMeta.executadoumaronda)}%</Typography>
                                            </Tooltip>
                                        </span>

                                        <span style={{ display: 'flex', alignItems: 'center', marginRight: '16px' }}>
                                            <LooksTwoIcon style={{ marginRight: '2px', color: 'green' }} />
                                            <Tooltip title="Porcentagem de Instalações que receberam 2 rondas no mês">
                                                <Typography variant="body1">{parseInt(infoDashboard.dadosMeta.executadoduasrondas)}%</Typography>
                                            </Tooltip>
                                        </span>
                                    </div>



                                </Grid>

                                <Grid item xs={12} sm={3}
                                    style={{
                                        padding: '10px',
                                        backgroundColor: darkMode ? '#0f3d63' : '#00008B',
                                        border: darkMode ? '1px solid rgba(255, 255, 255, 0.1)' : 'none',
                                        color: 'white',
                                        borderRadius: '8px',
                                        textAlign: 'center',
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        margin: '2px',
                                    }}
                                    alignItems="center"
                                    justifyContent="center"
                                >
                                    <SecurityIcon />
                                    <span style={{ fontWeight: 'bold' }}>
                                        Rondas Virtuais Hoje
                                    </span>

                                    <Grid item xs={12} container
                                        direction={'row'}
                                        style={{ paddingTop: 2 }}
                                        alignItems="center"
                                        justifyContent="center"
                                    >
                                        <span style={{ textAlign: 'center', margin: '1px', fontSize: 32, fontWeight: 'bold' }}>
                                            {infoDashboard.dashboardInfo.totalHoje}
                                        </span>
                                    </Grid>

                                    <Box
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            marginTop: '2px',
                                            alignItems: 'center',
                                        }}
                                    >
                                        {/* Exibição de Total de Ontem */}
                                        <Typography variant="body2" style={{ color: '#e0e0e0' }}>
                                            {infoDashboard.dashboardInfo.totalOntem} Ontem
                                        </Typography>

                                        <Box style={{ display: 'flex', alignItems: 'center' }}>
                                            {infoDashboard.dashboardInfo.totalHoje > infoDashboard.dashboardInfo.totalOntem ? (
                                                <>
                                                    <ArrowUpward style={{ color: 'green' }} />
                                                    <Typography variant="body2" style={{ color: 'green', marginLeft: '5px' }}>
                                                        {(((infoDashboard.dashboardInfo.totalHoje - infoDashboard.dashboardInfo.totalOntem) / infoDashboard.dashboardInfo.totalOntem) * 100).toFixed(2)}%
                                                    </Typography>
                                                </>
                                            ) : (
                                                <>
                                                    <ArrowDownward style={{ color: 'red' }} />
                                                    <Typography variant="body2" style={{ color: 'red', marginLeft: '5px' }}>
                                                        {(((infoDashboard.dashboardInfo.totalOntem - infoDashboard.dashboardInfo.totalHoje) / infoDashboard.dashboardInfo.totalOntem) * 100).toFixed(2)}%
                                                    </Typography>
                                                </>
                                            )}
                                        </Box>
                                    </Box>
                                </Grid>

                                <Grid item xs={12} sm={3}
                                    style={{
                                        padding: '10px',
                                        backgroundColor: darkMode ? '#1e2040' : '#191970',
                                        border: darkMode ? '1px solid rgba(255, 255, 255, 0.1)' : 'none',
                                        color: 'white',
                                        borderRadius: '8px',
                                        textAlign: 'center',
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        margin: '2px',
                                    }}
                                    alignItems="center"
                                    justifyContent="center"
                                >
                                    <AccessTimeIcon />
                                    <span style={{ fontWeight: 'bold', fontSize: 12 }}>
                                        Duração média da RV Hoje
                                    </span>

                                    <Grid item xs={12} container
                                        direction={'row'}
                                        style={{ paddingTop: 2 }}
                                        alignItems="center"
                                        justifyContent="center"
                                    >
                                        <span style={{ textAlign: 'center', margin: '1px', fontSize: 32, fontWeight: 'bold' }}>
                                            {parseInt(infoDashboard.dashboardInfo.duracaoHoje) + " minutos"}
                                        </span>
                                    </Grid>

                                    <Box
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            marginTop: '2px',
                                            alignItems: 'center',
                                        }}
                                    >
                                        {/* Exibição de Total de Ontem */}
                                        <Typography variant="body2" style={{ color: '#e0e0e0' }}>
                                            {parseInt(infoDashboard.dashboardInfo.duracaoOntem) + " minutos"} Ontem
                                        </Typography>

                                        <Box style={{ display: 'flex', alignItems: 'center' }}>
                                            {infoDashboard.dashboardInfo.duracaoHoje > infoDashboard.dashboardInfo.duracaoOntem ? (
                                                <>
                                                    <ArrowUpward style={{ color: 'green' }} />
                                                    <Typography variant="body2" style={{ color: 'green', marginLeft: '5px' }}>
                                                        {(((infoDashboard.dashboardInfo.duracaoHoje - infoDashboard.dashboardInfo.duracaoOntem) / infoDashboard.dashboardInfo.duracaoOntem) * 100).toFixed(2)}%
                                                    </Typography>
                                                </>
                                            ) : (
                                                <>
                                                    <ArrowDownward style={{ color: 'red' }} />
                                                    <Typography variant="body2" style={{ color: 'red', marginLeft: '5px' }}>
                                                        {(((infoDashboard.dashboardInfo.duracaoOntem - infoDashboard.dashboardInfo.duracaoHoje) / infoDashboard.dashboardInfo.duracaoOntem) * 100).toFixed(2)}%
                                                    </Typography>
                                                </>
                                            )}
                                        </Box>
                                    </Box>
                                </Grid>



                                <Grid item xs={12} sm={3}
                                    style={{
                                        padding: '10px',
                                        backgroundColor: darkMode ? '#134e4a' : '#008B8B',
                                        border: darkMode ? '1px solid rgba(255, 255, 255, 0.1)' : 'none',
                                        color: 'white',
                                        borderRadius: '8px',
                                        textAlign: 'center',
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        margin: '2px'
                                    }}
                                    alignItems="center"
                                    justifyContent="center"
                                >
                                    <SecurityIcon />
                                    <span style={{ fontWeight: 'bold' }}>
                                        Rondas Virtuais no Mês
                                    </span>

                                    <Grid item xs={12} container
                                        direction={'row'}
                                        style={{ paddingTop: 2 }}
                                        alignItems="center"
                                        justifyContent="center"
                                    >
                                        <span style={{ textAlign: 'center', margin: '1px', fontSize: 32, fontWeight: 'bold' }}>
                                            {infoDashboard.dashboardInfo.totalMes}
                                        </span>
                                    </Grid>

                                    <Box
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            marginTop: '2px',
                                            alignItems: 'center',
                                        }}
                                    >
                                        {/* Exibição de Total de Ontem */}
                                        <Typography variant="body2" style={{ color: '#e0e0e0' }}>
                                            {infoDashboard.dashboardInfo.totalMesPassado} Mês Passado
                                        </Typography>

                                        <Box style={{ display: 'flex', alignItems: 'center' }}>
                                            {infoDashboard.dashboardInfo.totalMes > infoDashboard.dashboardInfo.totalMesPassado ? (
                                                <>
                                                    <ArrowUpward style={{ color: 'green' }} />
                                                    <Typography variant="body2" style={{ color: 'green', marginLeft: '5px' }}>
                                                        {(((infoDashboard.dashboardInfo.totalMes - infoDashboard.dashboardInfo.totalMesPassado) / infoDashboard.dashboardInfo.totalMesPassado) * 100).toFixed(2)}%
                                                    </Typography>
                                                </>
                                            ) : (
                                                <>
                                                    <ArrowDownward style={{ color: 'red' }} />
                                                    <Typography variant="body2" style={{ color: 'red', marginLeft: '5px' }}>
                                                        {(((infoDashboard.dashboardInfo.totalMesPassado - infoDashboard.dashboardInfo.totalMes) / infoDashboard.dashboardInfo.totalMesPassado) * 100).toFixed(2)}%
                                                    </Typography>
                                                </>
                                            )}
                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid>


                            {/* Linha 2*/}
                            <Grid item xs={12} container
                                style={{ width: '100%', margin: 1 }}
                                direction={'row'} >

                                <Grid item xs={8}
                                    style={{
                                        padding: '12px',
                                        backgroundColor: darkMode ? '#1e1e1e' : '#ffffff',
                                        color: darkMode ? '#fff' : '#333',
                                        border: darkMode ? '1px solid #333' : '1px solid #e0e0e0',
                                        borderRadius: '8px',
                                        textAlign: 'center',
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        marginTop: '5px',
                                        marginRight: '12px',
                                    }}
                                    alignItems="center"
                                    justifyContent="center"
                                >
                                    <div style={{ width: '100%', height: '100%' }}>
                                        <ReactApexChart
                                            key={darkMode ? 'chart-dark' : 'chart-light'}
                                            options={chartOptions}
                                            series={dadosGrafico.series}
                                            type="line"
                                            height={350}
                                        />
                                    </div>
                                </Grid>

                                <Grid item xs={12} sm={3}
                                    style={{
                                        padding: '10px',
                                        backgroundColor: darkMode ? '#1e1e1e' : '#191970',
                                        border: darkMode ? '1px solid #333' : 'none',
                                        color: 'white',
                                        borderRadius: '8px',
                                        textAlign: 'center',
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        marginTop: '5px',
                                        marginRight: 15,
                                        maxHeight: '400px', // Limita a altura total
                                        overflowY: 'auto',  // Adiciona rolagem vertical
                                    }}
                                    alignItems="center"
                                    justifyContent="center"
                                >
                                    {/* Cabeçalho */}
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            fontWeight: 'bold',
                                            padding: '5px',
                                            borderBottom: darkMode ? '1px solid #444' : '1px solid white',
                                            color: darkMode ? '#fff' : 'white',
                                        }}
                                    >
                                        <span style={{ flex: 1, fontSize: '12px' }}>{"       "}</span>
                                        <span style={{ flex: 1, fontSize: '12px' }}>Nome</span>
                                        <span style={{ flex: 1, fontSize: '12px' }}>RVs</span>
                                    </div>

                                    {/* Linhas do Ranking - Renderiza com base na seleção */}
                                    {infoDashboard[`rankingDiario${rankingSelecao}`]?.map((ranking, index) => (
                                        <div
                                            key={index}
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                padding: '5px',
                                                backgroundColor: index % 2 === 0 ? (darkMode ? '#2d2d2d' : '#f0f0f0') : (darkMode ? '#1e1e1e' : '#ffffff'),
                                                color: darkMode ? '#fff' : 'black',
                                                fontSize: '14px',
                                            }}
                                        >
                                            <span style={{ flex: 1, textAlign: 'center' }}>
                                                {index === 0 ? '👑' : index === 1 ? '🥈' : index === 2 ? '🥉' : index + 1}
                                            </span>
                                            <span style={{ flex: 1, textAlign: 'center' }}>{ranking.nomeAmigavel}</span>
                                            <span style={{ flex: 1, textAlign: 'center' }}>{ranking.rondas}</span>
                                        </div>
                                    ))}

                                    {/* Bolinhas de Seleção */}
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            marginTop: '10px',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <button
                                            onClick={() => setRankingSelecao('Hoje')}
                                            style={{
                                                backgroundColor: rankingSelecao === 'Hoje' ? '#ffcc00' : 'transparent',
                                                border: '2px solid #ffcc00',
                                                borderRadius: '50%',
                                                width: '20px',
                                                height: '20px',
                                                margin: '0 5px',
                                            }}
                                        />
                                        <span style={{ marginRight: '10px', fontSize: '12px', color: 'white' }}>Hoje</span>

                                        <button
                                            onClick={() => setRankingSelecao('Ontem')}
                                            style={{
                                                backgroundColor: rankingSelecao === 'Ontem' ? '#ffcc00' : 'transparent',
                                                border: '2px solid #ffcc00',
                                                borderRadius: '50%',
                                                width: '20px',
                                                height: '20px',
                                                margin: '0 5px',
                                            }}
                                        />
                                        <span style={{ marginRight: '10px', fontSize: '12px', color: 'white' }}>Ontem</span>

                                        <button
                                            onClick={() => setRankingSelecao('Mes')}
                                            style={{
                                                backgroundColor: rankingSelecao === 'Mes' ? '#ffcc00' : 'transparent',
                                                border: '2px solid #ffcc00',
                                                borderRadius: '50%',
                                                width: '20px',
                                                height: '20px',
                                                margin: '0 5px',
                                            }}
                                        />
                                        <span style={{ fontSize: '12px', color: 'white' }}>Mês</span>
                                        <button
                                            onClick={() => setRankingSelecao('TodoPeriodo')}
                                            style={{
                                                backgroundColor: rankingSelecao === 'TodoPeriodo' ? '#ffcc00' : 'transparent',
                                                border: '2px solid #ffcc00',
                                                borderRadius: '50%',
                                                width: '20px',
                                                height: '20px',
                                                margin: '0 5px',
                                            }}
                                        />
                                        <span style={{ fontSize: '12px', color: 'white' }}>Histórico</span>

                                    </div>
                                </Grid>



                                <Button style={{ margin: 5 }}
                                    variant="contained"
                                    color="primary"
                                    onClick={listarHistorico}
                                >
                                    Histórico Completo
                                </Button>





                            </Grid>


                        </Grid>
                    }
                </div>

            }

            {
                value === 1 &&
                <div style={{
                    paddingTop: 8,
                    paddingBottom: 8,
                    paddingLeft: drawerWidth + 12,
                    paddingRight: 15,
                    backgroundColor: darkMode ? '#121212' : 'transparent',
                    transition: 'padding-left 0.3s ease',
                    height: 'calc(100vh - 75px)',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    boxSizing: 'border-box'
                }}>
                    {loading ?
                        <Skeleton animation={"wave"} width={'100%'} height={400} style={{ backgroundColor: '#48D1CC' }} />
                        :
                        <div style={{ flex: 1, height: '100%', minHeight: 0, display: 'flex', flexDirection: 'column' }}>
                            {rondasVirtuais && (
                                <ThemeProvider theme={tableTheme}>
                                    <CssBaseline />
                                    <MaterialReactTable
                                        table={table}
                                    />
                                </ThemeProvider>
                            )}
                        </div>
                    }
                </div>
            }

            {
                value === 2 &&
                <div style={{ paddingTop: 5, paddingLeft: drawerWidth + 12, paddingRight: 15, backgroundColor: darkMode ? '#121212' : 'transparent', color: darkMode ? '#fff' : 'inherit', transition: 'padding-left 0.3s ease', minHeight: '100vh' }}>
                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="center"
                        item xs={12}
                    >
                        {loadingRelatoria ?
                            <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
                            </Skeleton>
                            :
                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-start"
                                alignItems="center"
                                item xs={12}
                                spacing={2}
                            >
                                {/* Select do mês */}
                                <FormControl
                                    sx={{
                                        minWidth: 120,
                                        margin: '5px',
                                        '& .MuiInputLabel-root': { color: darkMode ? '#fff' : 'inherit' },
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': { borderColor: darkMode ? 'rgba(255, 255, 255, 0.23)' : 'inherit' },
                                            '&:hover fieldset': { borderColor: darkMode ? '#fff' : 'inherit' },
                                            '&.Mui-focused fieldset': { borderColor: darkMode ? '#fff' : 'inherit' },
                                            color: darkMode ? '#fff' : 'inherit',
                                        },
                                        '& .MuiSelect-icon': { color: darkMode ? '#fff' : 'inherit' },
                                    }}
                                >
                                    <InputLabel>Tipo de Grupo</InputLabel>
                                    <Select value={tipoGrupo} onChange={(e) => handleGrupo(e.target.value)} label="Tipo de Grupo">
                                        <MenuItem key={0} value={0}>
                                            {"Grupo de Cliente"}
                                        </MenuItem>
                                        <MenuItem key={1} value={1}>
                                            {"Grupo de Controle"}
                                        </MenuItem>

                                    </Select>
                                </FormControl>

                                {parseInt(tipoGrupo, 10) === 0 && (
                                    <FormControl
                                        sx={{
                                            minWidth: 280,
                                            maxWidth: 400,
                                            margin: '5px',
                                            '& .MuiInputLabel-root': { color: darkMode ? '#fff' : 'inherit' },
                                            '& .MuiOutlinedInput-root': {
                                                '& fieldset': { borderColor: darkMode ? 'rgba(255, 255, 255, 0.23)' : 'inherit' },
                                                '&:hover fieldset': { borderColor: darkMode ? '#fff' : 'inherit' },
                                                '&.Mui-focused fieldset': { borderColor: darkMode ? '#fff' : 'inherit' },
                                                color: darkMode ? '#fff' : 'inherit',
                                            },
                                            '& .MuiSelect-icon': { color: darkMode ? '#fff' : 'inherit' },
                                        }}
                                    >
                                        <InputLabel id="label-grupo-cliente-multi">Grupos de Cliente</InputLabel>
                                        <Select
                                            labelId="label-grupo-cliente-multi"
                                            multiple
                                            value={gruposClienteSelecionados.map((g) => g.id_grupo_cliente)}
                                            onChange={(e) => {
                                                const selectedIds = e.target.value;
                                                if (selectedIds.includes("all")) {
                                                    if (gruposClienteSelecionados.length === gruposCliente.length) {
                                                        setGruposClienteSelecionados([]);
                                                    } else {
                                                        setGruposClienteSelecionados([...gruposCliente]);
                                                    }
                                                } else {
                                                    const selectedObjs = gruposCliente.filter((g) => selectedIds.includes(g.id_grupo_cliente));
                                                    setGruposClienteSelecionados(selectedObjs);
                                                }
                                            }}
                                            input={<OutlinedInput label="Grupos de Cliente" />}
                                            renderValue={(selected) => {
                                                if (selected.length === 0) return "Nenhum grupo selecionado";
                                                if (selected.length === gruposCliente.length) return "Todos os Grupos de Cliente";
                                                return gruposCliente
                                                    .filter((g) => selected.includes(g.id_grupo_cliente))
                                                    .map((g) => g.nome)
                                                    .join(', ');
                                            }}
                                        >
                                            <MenuItem value="all" sx={{ fontWeight: 'bold', borderBottom: '1px solid #ccc' }}>
                                                <Checkbox
                                                    checked={gruposCliente.length > 0 && gruposClienteSelecionados.length === gruposCliente.length}
                                                    indeterminate={gruposClienteSelecionados.length > 0 && gruposClienteSelecionados.length < gruposCliente.length}
                                                />
                                                <ListItemText primary="Marcar Todos" />
                                            </MenuItem>
                                            {gruposCliente.map((g) => (
                                                <MenuItem key={g.id_grupo_cliente} value={g.id_grupo_cliente}>
                                                    <Checkbox checked={gruposClienteSelecionados.some((sel) => sel.id_grupo_cliente === g.id_grupo_cliente)} />
                                                    <ListItemText primary={`${g.id_grupo_cliente} - ${g.nome}`} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                )}

                                {parseInt(tipoGrupo, 10) === 1 && (
                                    <FormControl
                                        sx={{
                                            minWidth: 280,
                                            maxWidth: 400,
                                            margin: '5px',
                                            '& .MuiInputLabel-root': { color: darkMode ? '#fff' : 'inherit' },
                                            '& .MuiOutlinedInput-root': {
                                                '& fieldset': { borderColor: darkMode ? 'rgba(255, 255, 255, 0.23)' : 'inherit' },
                                                '&:hover fieldset': { borderColor: darkMode ? '#fff' : 'inherit' },
                                                '&.Mui-focused fieldset': { borderColor: darkMode ? '#fff' : 'inherit' },
                                                color: darkMode ? '#fff' : 'inherit',
                                            },
                                            '& .MuiSelect-icon': { color: darkMode ? '#fff' : 'inherit' },
                                        }}
                                    >
                                        <InputLabel id="label-grupo-controle-multi">Grupos de Controle</InputLabel>
                                        <Select
                                            labelId="label-grupo-controle-multi"
                                            multiple
                                            value={gruposControlesSelecionados.map((g) => g.id_grupo_controle)}
                                            onChange={(e) => {
                                                const selectedIds = e.target.value;
                                                if (selectedIds.includes("all")) {
                                                    if (gruposControlesSelecionados.length === gruposControle.length) {
                                                        setGruposControlesSelecionados([]);
                                                    } else {
                                                        setGruposControlesSelecionados([...gruposControle]);
                                                    }
                                                } else {
                                                    const selectedObjs = gruposControle.filter((g) => selectedIds.includes(g.id_grupo_controle));
                                                    setGruposControlesSelecionados(selectedObjs);
                                                }
                                            }}
                                            input={<OutlinedInput label="Grupos de Controle" />}
                                            renderValue={(selected) => {
                                                if (selected.length === 0) return "Nenhum grupo selecionado";
                                                if (selected.length === gruposControle.length) return "Todos os Grupos de Controle";
                                                return gruposControle
                                                    .filter((g) => selected.includes(g.id_grupo_controle))
                                                    .map((g) => g.nome)
                                                    .join(', ');
                                            }}
                                        >
                                            <MenuItem value="all" sx={{ fontWeight: 'bold', borderBottom: '1px solid #ccc' }}>
                                                <Checkbox
                                                    checked={gruposControle.length > 0 && gruposControlesSelecionados.length === gruposControle.length}
                                                    indeterminate={gruposControlesSelecionados.length > 0 && gruposControlesSelecionados.length < gruposControle.length}
                                                />
                                                <ListItemText primary="Marcar Todos" />
                                            </MenuItem>
                                            {gruposControle.map((g) => (
                                                <MenuItem key={g.id_grupo_controle} value={g.id_grupo_controle}>
                                                    <Checkbox checked={gruposControlesSelecionados.some((sel) => sel.id_grupo_controle === g.id_grupo_controle)} />
                                                    <ListItemText primary={`${g.id_grupo_controle} - ${g.nome}`} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                )}
                                {/* Select dos meses (Múltipla Escolha) */}
                                <FormControl
                                    sx={{
                                        minWidth: 220,
                                        margin: '5px',
                                        '& .MuiInputLabel-root': { color: darkMode ? '#fff' : 'inherit' },
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': { borderColor: darkMode ? 'rgba(255, 255, 255, 0.23)' : 'inherit' },
                                            '&:hover fieldset': { borderColor: darkMode ? '#fff' : 'inherit' },
                                            '&.Mui-focused fieldset': { borderColor: darkMode ? '#fff' : 'inherit' },
                                            color: darkMode ? '#fff' : 'inherit',
                                        },
                                        '& .MuiSelect-icon': { color: darkMode ? '#fff' : 'inherit' },
                                    }}
                                >
                                    <InputLabel id="label-meses-multi">Meses</InputLabel>
                                    <Select
                                        labelId="label-meses-multi"
                                        multiple
                                        value={selectedMonths}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            if (val.includes("all")) {
                                                if (selectedMonths.length === months.length) {
                                                    setSelectedMonths([]);
                                                } else {
                                                    setSelectedMonths(months.map(m => m.value));
                                                }
                                            } else {
                                                setSelectedMonths(typeof val === 'string' ? val.split(',').map(Number) : val);
                                            }
                                        }}
                                        input={<OutlinedInput label="Meses" />}
                                        renderValue={(selected) => {
                                            if (selected.length === 0) return "Nenhum mês selecionado";
                                            if (selected.length === months.length) return "Todos os Meses";
                                            return selected
                                                .map((val) => months.find((m) => m.value === val)?.label)
                                                .filter(Boolean)
                                                .join(', ');
                                        }}
                                    >
                                        <MenuItem value="all" sx={{ fontWeight: 'bold', borderBottom: '1px solid #ccc' }}>
                                            <Checkbox
                                                checked={months.length > 0 && selectedMonths.length === months.length}
                                                indeterminate={selectedMonths.length > 0 && selectedMonths.length < months.length}
                                            />
                                            <ListItemText primary="Marcar Todos" />
                                        </MenuItem>
                                        {months.map((m) => (
                                            <MenuItem key={m.value} value={m.value}>
                                                <Checkbox checked={selectedMonths.indexOf(m.value) > -1} />
                                                <ListItemText primary={m.label} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                                {/* TextField para o ano */}
                                <TextField
                                    label="Ano"
                                    variant="outlined"
                                    value={year}
                                    onChange={handleYearChange}
                                    sx={{
                                        margin: '5px',
                                        '& .MuiInputLabel-root': { color: darkMode ? '#fff' : 'inherit' },
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': { borderColor: darkMode ? 'rgba(255, 255, 255, 0.23)' : 'inherit' },
                                            '&:hover fieldset': { borderColor: darkMode ? '#fff' : 'inherit' },
                                            '&.Mui-focused fieldset': { borderColor: darkMode ? '#fff' : 'inherit' },
                                            color: darkMode ? '#fff' : 'inherit',
                                        },
                                    }}
                                    inputProps={{
                                        maxLength: 4,
                                        pattern: "[0-9]*", // Apenas números
                                    }}
                                />

                                <Button style={{ margin: 5 }}
                                    variant="contained"
                                    color="primary"
                                    disabled={inGeracao}
                                    onClick={gerarRelatorioRondaVirtual}
                                > Gerar  </Button>

                                {/* Componente de Árvore de Instalações dos Grupos */}
                                {treeGrupos && treeGrupos.length > 0 && (
                                    <Grid item xs={12} style={{ marginTop: 15, width: '100%' }}>
                                        <Card variant="outlined" sx={{ backgroundColor: darkMode ? '#262626' : '#f8fafc', borderColor: darkMode ? '#444' : '#e2e8f0', borderRadius: '8px', width: '100%' }}>
                                            <Box sx={{ padding: '12px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', borderBottom: treeOpen ? '1px solid ' + (darkMode ? '#444' : '#e2e8f0') : 'none' }} onClick={() => setTreeOpen(!treeOpen)}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <BusinessIcon color="primary" />
                                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: darkMode ? '#fff' : '#1e293b' }}>
                                                        Árvore de Instalações ({treeGrupos.reduce((acc, g) => acc + (g.instalacoes?.length || 0), 0)} instalações em {treeGrupos.length} grupos)
                                                    </Typography>
                                                </Box>
                                                <IconButton size="small">
                                                    {treeOpen ? <ExpandMoreIcon sx={{ color: darkMode ? '#fff' : 'inherit' }} /> : <ChevronRightIcon sx={{ color: darkMode ? '#fff' : 'inherit' }} />}
                                                </IconButton>
                                            </Box>
                                            <Collapse in={treeOpen}>
                                                <CardContent sx={{ padding: '12px 16px' }}>
                                                    {loadingTree ? (
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, padding: 2 }}>
                                                            <CircularProgress size={20} />
                                                            <Typography variant="body2">Carregando instalações da árvore...</Typography>
                                                        </Box>
                                                    ) : (
                                                        <Box sx={{ pl: 1 }}>
                                                            {treeGrupos.map((grupoNode, gIdx) => (
                                                                <Box key={grupoNode.idGrupo || gIdx} sx={{ mb: 2 }}>
                                                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: darkMode ? '#90caf9' : '#0288d1', display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                                                        📁 {grupoNode.grupoNome} ({grupoNode.instalacoes?.length || 0} instalações)
                                                                    </Typography>
                                                                    {(!grupoNode.instalacoes || grupoNode.instalacoes.length === 0) ? (
                                                                        <Typography variant="caption" sx={{ color: darkMode ? '#aaa' : '#64748b', fontStyle: 'italic', pl: 3 }}>
                                                                            Nenhuma instalação vinculada a este grupo.
                                                                        </Typography>
                                                                    ) : (
                                                                        <Box sx={{ pl: 3 }}>
                                                                            {grupoNode.instalacoes.map((inst, idx) => {
                                                                                const nomeInst = inst.tipo_instalacao === 0
                                                                                    ? `${inst.nome || ''} ${inst.sobrenome || ''}`
                                                                                    : (inst.nome_empresarial && inst.nome_empresarial.trim() !== '' ? inst.nome_empresarial : inst.nome_fantasia || inst.razao_social || inst.nome);
                                                                                const endereco = [inst.logradouro, inst.numero ? `nº ${inst.numero}` : null, inst.bairro, inst.cidade ? `${inst.cidade}/${inst.estado || ''}` : null].filter(Boolean).join(', ');

                                                                                return (
                                                                                    <Box key={inst.id_instalacao || idx} sx={{ mb: 1, pb: 0.5, borderBottom: idx < grupoNode.instalacoes.length - 1 ? '1px dashed ' + (darkMode ? '#333' : '#e2e8f0') : 'none' }}>
                                                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                                            <HomeIcon fontSize="small" sx={{ color: '#0288d1' }} />
                                                                                            <Typography variant="body2" sx={{ fontWeight: 'bold', color: darkMode ? '#e2e8f0' : '#334155' }}>
                                                                                                [{inst.identificador_integrador || inst.id_instalacao}] {nomeInst}
                                                                                            </Typography>
                                                                                        </Box>
                                                                                        {endereco && (
                                                                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, pl: 3, mt: 0.5 }}>
                                                                                                <LocationOnIcon fontSize="inherit" sx={{ color: darkMode ? '#aaa' : '#64748b', fontSize: 14 }} />
                                                                                                <Typography variant="caption" sx={{ color: darkMode ? '#ccc' : '#475569' }}>
                                                                                                    {endereco} {inst.cep ? `— CEP: ${inst.cep}` : ''}
                                                                                                </Typography>
                                                                                            </Box>
                                                                                        )}
                                                                                    </Box>
                                                                                );
                                                                            })}
                                                                        </Box>
                                                                    )}
                                                                </Box>
                                                            ))}
                                                        </Box>
                                                    )}
                                                </CardContent>
                                            </Collapse>
                                        </Card>
                                    </Grid>
                                )}
                            </Grid>
                        }
                    </Grid>



                </div>
            }


            <Drawer
                variant="permanent"
                anchor="left"
                sx={{
                    top: '100px', // Ajuste conforme a altura do NavegadorGestao
                    height: 'calc(100vh - 100px)',
                    zIndex: 999,
                    '& .MuiDrawer-paper': {
                        position: 'fixed',
                        top: '100px', // Ajuste conforme a altura do NavegadorGestao
                        width: `${drawerWidth}px`,
                        transition: 'width 0.3s ease',
                        overflowX: 'hidden',
                        backgroundColor: darkMode ? '#1e1e1e' : '#ffffff',
                        color: darkMode ? '#fff' : 'inherit',
                        borderRight: darkMode ? '1px solid #333' : '1px solid #e0e0e0',
                        boxShadow: '2px 0 8px rgba(0, 0, 0, 0.1)',
                    },
                    '& .MuiListItemIcon-root svg': {
                        color: darkMode ? '#fff' : 'inherit',
                    },
                    '& .MuiListItemText-primary': {
                        color: darkMode ? '#fff' : 'inherit',
                        fontWeight: '500',
                    },
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: menuAberto ? 'flex-end' : 'center',
                        p: 1,
                        borderBottom: darkMode ? '1px solid #333' : '1px solid #eee',
                    }}
                >
                    <Tooltip title={menuAberto ? "Recolher menu" : "Expandir menu"} placement="right">
                        <IconButton
                            size="small"
                            onClick={handleToggleMenu}
                            sx={{ color: darkMode ? '#fff' : '#555' }}
                        >
                            {menuAberto ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                        </IconButton>
                    </Tooltip>
                </Box>
                <List sx={{ pt: 0.5 }}>
                    <Tooltip title={!menuAberto ? "Dashboard" : ""} placement="right">
                        <ListItem
                            sx={{
                                backgroundColor: value === 0 ? 'orange' : 'transparent',
                                justifyContent: menuAberto ? 'initial' : 'center',
                                px: 2,
                                py: 1.2,
                                borderRadius: '6px',
                                mx: '4px',
                                width: 'calc(100% - 8px)',
                                mb: 0.5,
                                transition: 'all 0.2s',
                                '&:hover': {
                                    backgroundColor: value === 0 ? '#ff9800' : (darkMode ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.04)'),
                                }
                            }}
                            button onClick={() => handleMenuClick(0)}>
                            <ListItemIcon sx={{ minWidth: 0, mr: menuAberto ? 2 : 'auto', justifyContent: 'center' }}>
                                <DashboardIcon />
                            </ListItemIcon>
                            {menuAberto && <ListItemText primary="Dashboard" sx={{ whiteSpace: 'nowrap' }} />}
                        </ListItem>
                    </Tooltip>

                    <Tooltip title={!menuAberto ? "Rondas Virtuais" : ""} placement="right">
                        <ListItem
                            sx={{
                                backgroundColor: value === 1 ? 'orange' : 'transparent',
                                justifyContent: menuAberto ? 'initial' : 'center',
                                px: 2,
                                py: 1.2,
                                borderRadius: '6px',
                                mx: '4px',
                                width: 'calc(100% - 8px)',
                                mb: 0.5,
                                transition: 'all 0.2s',
                                '&:hover': {
                                    backgroundColor: value === 1 ? '#ff9800' : (darkMode ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.04)'),
                                }
                            }}
                            button onClick={() => handleMenuClick(1)}>
                            <ListItemIcon sx={{ minWidth: 0, mr: menuAberto ? 2 : 'auto', justifyContent: 'center' }}>
                                <PostAddIcon />
                            </ListItemIcon>
                            {menuAberto && <ListItemText primary="Rondas Virtuais" sx={{ whiteSpace: 'nowrap' }} />}
                        </ListItem>
                    </Tooltip>

                    <Tooltip title={!menuAberto ? "Relatórios" : ""} placement="right">
                        <ListItem
                            sx={{
                                backgroundColor: value === 2 ? 'orange' : 'transparent',
                                justifyContent: menuAberto ? 'initial' : 'center',
                                px: 2,
                                py: 1.2,
                                borderRadius: '6px',
                                mx: '4px',
                                width: 'calc(100% - 8px)',
                                mb: 0.5,
                                transition: 'all 0.2s',
                                '&:hover': {
                                    backgroundColor: value === 2 ? '#ff9800' : (darkMode ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.04)'),
                                }
                            }}
                            button onClick={() => handleMenuClick(2)}
                        >
                            <ListItemIcon sx={{ minWidth: 0, mr: menuAberto ? 2 : 'auto', justifyContent: 'center' }}>
                                <AssessmentIcon />
                            </ListItemIcon>
                            {menuAberto && <ListItemText primary="Relatoria" sx={{ whiteSpace: 'nowrap' }} />}
                        </ListItem>
                    </Tooltip>
                </List>
            </Drawer>




            <Dialog open={openSnaRondaVirtual} onClose={handleCloseSnaRondaVirtual} PaperProps={{ style: { maxWidth: '1000px', minWidth: '800px', backgroundColor: darkMode ? '#121212' : undefined, color: darkMode ? '#fff' : undefined } }}>
                <DialogContent style={{ backgroundColor: darkMode ? '#121212' : undefined, color: darkMode ? '#fff' : undefined }}>
                    <SNARonda
                        rondaVirtual={rondaVirtualSna}
                        darkMode={darkMode}
                    />
                </DialogContent>
            </Dialog>


            <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={inGeracao}>
                <CircularProgress color="inherit" />
                <Box mt={2}>
                    <Typography variant="h6">Aguarde enquanto o servidor trabalha na geração do relatório</Typography>
                </Box>
            </Backdrop>


            <Dialog
                open={openHistorico}
                onClose={handleCloseHistorico}
                PaperProps={{ style: { maxWidth: '1600px', minWidth: '1200px', minHeight: '500px', backgroundColor: darkMode ? '#121212' : undefined, color: darkMode ? '#fff' : 'inherit' } }}
            >
                <DialogContent style={{ backgroundColor: darkMode ? '#121212' : undefined, color: darkMode ? '#fff' : 'inherit' }}>
                    <div style={{ display: 'flex', width: '100%', height: '100%' }}>
                        {/* Gráfico à esquerda */}
                        <div style={{ flex: 3, paddingRight: '10px' }}>
                            <ReactApexChart
                                key={darkMode ? 'hist-dark' : 'hist-light'}
                                options={historicoChartOptions}
                                series={dadosHistorico.series}
                                type="line"
                                height={500}
                            />
                        </div>

                        {/* Ranking à direita */}
                        <div
                            style={{
                                flex: 1,
                                padding: '5px',
                                backgroundColor: '#191970',
                                color: 'white',
                                borderRadius: '8px',
                                textAlign: 'center',
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                maxHeight: '400px',
                                overflowY: 'auto',
                            }}
                        >
                            <span style={{ fontSize: 'bold' }}>{mesObservado}</span>

                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    fontWeight: 'bold',
                                    padding: '5px',
                                    borderBottom: darkMode ? '1px solid #444' : '1px solid white',
                                    color: darkMode ? '#fff' : 'inherit',
                                }}
                            >
                                <span style={{ flex: 1, fontSize: '12px' }}>#</span>
                                <span style={{ flex: 1, fontSize: '12px' }}>Nome</span>
                                <span style={{ flex: 1, fontSize: '12px' }}>RVs</span>
                            </div>

                            {rankingDoGrafico?.map((ranking, index) => (
                                <div
                                    key={index}
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        padding: '5px',
                                        backgroundColor: index % 2 === 0 ? (darkMode ? '#2d2d2d' : '#f0f0f0') : (darkMode ? '#1e1e1e' : '#ffffff'),
                                        color: darkMode ? '#fff' : 'black',
                                        fontSize: '14px',
                                    }}
                                >
                                    <span style={{ flex: 1, textAlign: 'center' }}>
                                        {index === 0 ? '👑' : index === 1 ? '🥈' : index === 2 ? '🥉' : index + 1}
                                    </span>
                                    <span style={{ flex: 1, textAlign: 'center' }}>{ranking.nomeAmigavel}</span>
                                    <span style={{ flex: 1, textAlign: 'center' }}>{ranking.totalRondas}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </DialogContent>
            </Dialog>


        </div>
    );
}



